import { render, staticRenderFns } from "./android_ios_pay.vue?vue&type=template&id=1eced838&scoped=true"
import script from "./android_ios_pay.vue?vue&type=script&lang=js"
export * from "./android_ios_pay.vue?vue&type=script&lang=js"
import style0 from "./android_ios_pay.vue?vue&type=style&index=0&id=1eced838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eced838",
  null
  
)

export default component.exports